export enum SalaryType {
  Hourly = "HOURLY",
  Monthly = "MONTHLY",
  Default = "",
}

export namespace SalaryType {
  export const fromString = (value?: string): SalaryType => {
    switch (value) {
      case SalaryType.Hourly:
        return SalaryType.Hourly;
      case SalaryType.Monthly:
        return SalaryType.Monthly;
      default:
        return SalaryType.Default;
    }
  }
}
